import moment from "moment";
import { DATA_PRODUCER_WORKSHEET_NAME } from "../globalValues";
import { DATA_PRODUCER_TABLE_NAME } from "./constants";
import { capitalizeFirstLetter } from "../../utils/capitalizeFirstLetter";
import { YieldType } from "../globalTypes";

export const setLastYieldSentAndTimestamp = async ({
  yieldType,
  value,
  row,
}: {
  yieldType: YieldType;
  value: string;
  row: number;
}) => {
  await Excel.run(async (context) => {
    const worksheet = context.workbook.worksheets.getItem(DATA_PRODUCER_WORKSHEET_NAME);
    const table = worksheet.tables.getItem(DATA_PRODUCER_TABLE_NAME);

    const yieldTypeCapitalized = capitalizeFirstLetter(yieldType);

    const timestampColumn = table.columns.getItem(`Last ${yieldTypeCapitalized} Timestamp`);
    const timestampCell = timestampColumn.getRange().getCell(row, 0);

    const yieldColumn = table.columns.getItem(`Last ${yieldTypeCapitalized} Sent`);
    const yieldCell = yieldColumn.getRange().getCell(row, 0);

    const formattedDate = moment().utc().format("HH:mm:ss DD-MMM-YYYY") + " (UTC)";

    timestampCell.values = [[formattedDate]];
    yieldCell.values = [[value]];

    timestampCell.format.autofitColumns();
    yieldCell.format.font.bold = true;
    yieldCell.format.horizontalAlignment = Excel.HorizontalAlignment.center;

    await context.sync();
  });
};
